(() => {
  const body = document.body;
  if (!body || !body.classList.contains('brand-e4e')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = '[data-e4e-reveal]';
  const visibleClass = 'is-visible';
  let observer = null;

  const revealNow = (root = document) => {
    const elements = root.matches?.(revealSelector)
      ? [root, ...root.querySelectorAll(revealSelector)]
      : Array.from(root.querySelectorAll(revealSelector));

    elements.forEach((element) => {
      element.classList.add(visibleClass);
    });
  };

  const initReveals = (root = document) => {
    const elements = root.matches?.(revealSelector)
      ? [root, ...root.querySelectorAll(revealSelector)]
      : Array.from(root.querySelectorAll(revealSelector));
    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      revealNow(root);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add(visibleClass);
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.16,
        }
      );
    }

    elements.forEach((element) => {
      if (element.classList.contains(visibleClass)) return;
      observer.observe(element);
    });
  };

  const createProgress = () => {
    let progress = document.querySelector('.e4e-scroll-progress');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'e4e-scroll-progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span></span>';
      body.appendChild(progress);
    }

    const fill = progress.querySelector('span');
    if (!fill) return;

    let ticking = false;

    const update = () => {
      const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const value = Math.min(Math.max(window.scrollY / max, 0), 1);
      fill.style.transform = `scaleX(${value})`;
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  };

  body.classList.add('e4e-motion-ready');
  initReveals();
  createProgress();

  document.addEventListener('shopify:section:load', (event) => {
    initReveals(event.target);
  });

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) revealNow();
  });
})();
